import { daysUntilDeadline } from './grant-format.js';
/**
 * 공고의 진행 단계.
 *
 * 마감일 하나로는 부족하다. 「선정 결과 발표」 공고는 마감일이 지났어도
 * 「마감」이 아니고 — 붙었는지 보러 오는 사람에게는 지금이 가장 중요한
 * 문서다 — 출처가 끝났다고 명시한 것은 날짜가 지난 것과 다른 사실이다.
 *
 * 목록에서 독자가 알아야 하는 건 하나다: **지금 뭘 할 수 있는가.**
 */
export const GRANT_PHASES = ['open', 'closing', 'closed', 'result', 'ended'];
const PHASE = {
    open: { label: '모집중', dot: '🟢' },
    closing: { label: '곧 마감', dot: '🟡' },
    closed: { label: '마감', dot: '🔴' },
    result: { label: '선정 결과', dot: '🔵' },
    ended: { label: '종료', dot: '⚫' },
};
/** 이 안쪽이면 「곧 마감」. 그 밖은 지금 움직일 이유가 없다. */
const CLOSING_DAYS = 7;
/**
 * 결과 공고를 제목에서 읽는다.
 *
 * **「선정」만으로는 안 된다.** 「선정 절차」·「선정 방법」은 모집 공고의
 * 본문 항목이라 그것까지 결과로 읽으면 멀쩡한 모집 공고가 사라진다.
 * 발표를 뜻하는 말이 함께 있어야 한다.
 */
const RESULT_RE = /(선정|합격|최종)\s*(결과|자|기업|팀|명단)|결과\s*(발표|공고|안내)|\[결과/;
export function grantPhase(grant, now) {
    const make = (key) => ({ key, ...PHASE[key] });
    if (RESULT_RE.test(grant.title))
        return make('result');
    const days = daysUntilDeadline(grant.applyEnd, now);
    if (days !== null) {
        // 날짜가 있으면 날짜가 더 구체적인 사실이다. 오늘은 아직 마감이 아니다 —
        // 자정까지 낼 수 있는데 「마감」으로 표시하면 포기시킨다.
        if (days < 0)
            return make('closed');
        return make(days <= CLOSING_DAYS ? 'closing' : 'open');
    }
    // 날짜가 없다. 출처가 끝났다고 했으면 종료, 아니면 상시 모집이다.
    return make(grant.status === 'closed' ? 'ended' : 'open');
}
//# sourceMappingURL=grant-phase.js.map